module.exports = __webpack_public_path__ + "static/media/Screenshot2.f30f54f5.png";